import React, { Component } from 'react';
import './Gantt.css';
import TimeLine from 'react-gantt-timeline';
import PropTypes from 'prop-types';
import moment from 'moment';
import Button from 'components/shared/button/Button';

const config = {
  header: {
    top: {
      style: {
        backgroundColor: '#3c4249',
      },
    },
    middle: {
      style: {
        backgroundColor: '#ef4834',
      },
    },
    bottom: {
      style: {
        background: '#8e9aae',
      },
    },
  },
  dataViewPort: {
    task: {
      showLabel: true,
      style: {
        borderRadius: 4,
        cursor: 'pointer',
      },
    },
  },
};

const itemheight = 40;

const colors = {
  pre: '#da2b48',
  wip: '#c63992',
  cmp: '#1279be',
};

export default class Gantt extends Component {
  constructor(props) {
    super(props);
    this.state = this.parseTasks(this.props);
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.updateOpenItems(this.props);
    }
  }

  render() {
    let buttonLabel = this.state.editing ? 'Save' : 'Edit';
    return (
      <div className="gantt">
        {this.state.editing && (
          <Button
            className="button-gray button-cancel"
            label="Cancel"
            onClick={this.handleCancelClick}
          />
        )}
        <Button
          className="button-orange button-edit"
          label={buttonLabel}
          onClick={this.handleEditClick}
        />
        <TimeLine
          data={this.state.data}
          onUpdateTask={this.onUpdateTask}
          onSelectItem={this.onSelectItem}
          config={config}
          itemheight={itemheight}
        />
      </div>
    );
  }

  handleEditClick = () => {
    if (this.state.editing) {
      this.saveSchedule();
    }

    this.setState({ editing: !this.state.editing });
  };

  saveSchedule = () => {
    let onWorkOrderUpdate = this.props.onWorkOrderUpdate;
    let onTaskUpdate = this.props.onTaskUpdate;
    this.state.data.forEach(function (item) {
      if (item.type === 'WORKORDER' && onWorkOrderUpdate) {
        onWorkOrderUpdate(item.id, item.start, item.end);
      } else if (item.type === 'TASK' && onTaskUpdate) {
        onTaskUpdate(item.id, item.start, item.end);
      }
    });
  };

  handleCancelClick = () => {
    this.setState(this.parseTasks(this.props));
    this.setState({ editing: !this.state.editing });
  };

  parseTasks = (props) => {
    let woStart = moment(
      props.workOrder.schedule_start_date ||
        props.workOrder.approved_proposal.start_date
    );
    let woEnd = props.workOrder.schedule_end_date
      ? moment(props.workOrder.schedule_end_date)
      : moment(props.workOrder.approved_proposal.completion_date).add(1, 'day');
    let tasks = [].concat({
      id: props.workOrder.id,
      start: woStart,
      end: woEnd,
      name: 'Client Start and Completion Dates',
      color: '#ef4834',
      type: 'WORKORDER',
    });

    props.quotes
      .filter(
        (quote) => quote.status === 'approved' && quote.task.status !== 'cls'
      )
      .sort((quote1, quote2) => {
        return (
          moment(quote1.task.schedule_start_date || quote1.start_date) -
          moment(quote2.task.schedule_start_date || quote2.start_date)
        );
      })
      .forEach(function (quote) {
        let task = props.tasks.find((t) => t.id === quote.task.id);
        let start = moment(task.schedule_start_date || quote.start_date);
        let end = task.schedule_end_date
          ? moment(task.schedule_end_date)
          : moment(quote.end_date).add(1, 'day');
        let color = colors[task.status];

        let taskSchedule = {
          id: task.id,
          start: start,
          end: end,
          name: `Task ${task.number} (${task.status.toUpperCase()}) - ${
            task.name
          }`,
          color: color,
          type: 'TASK',
          mltId: `MLT-${task.id}`,
        };

        let materialLeadTime = [];
        if (quote.material_lead_days) {
          materialLeadTime = {
            id: `MLT-${task.id}`,
            start: start,
            end: moment(start).add(quote.material_lead_days, 'days'),
            name: `Task ${task.number} - Material Lead Time`,
            color: color,
            leadDays: quote.material_lead_days,
          };
        }

        let openItems = props.openItems
          .filter((oi) => oi.task.id === task.id && !oi.resolved)
          .map(function (oi) {
            return {
              id: oi.id,
              start: moment(oi.created_at),
              end: moment(oi.due_date).add(1, 'day'),
              name: `Open Item ${oi.task.number}-${oi.letter} - ${oi.description}`,
              color: '#fab73d',
              type: 'OPENITEM',
            };
          });

        tasks = tasks.concat(taskSchedule, materialLeadTime, openItems);
      });

    return { data: tasks };
  };

  onUpdateTask = (item, props) => {
    if (!this.state.editing) {
      return;
    }
    if (item.type !== 'WORKORDER' && item.type !== 'TASK') {
      return;
    }

    props.start = moment(props.start).format('YYYY-MM-DD');
    props.end = moment(props.end).format('YYYY-MM-DD');
    let sameStart = moment(item.start).format('YYYY-MM-DD') === props.start;

    if (!sameStart) {
      if (item.type === 'TASK') {
        this.state.data
          .filter((i) => i.id === item.mltId)
          .forEach(function (i) {
            i.start = props.start;
            i.end = moment(props.start).add(i.leadDays, 'days');
          });
      } else if (item.type === 'WORKORDER') {
        let diffDays = moment(props.start).diff(moment(item.start), 'days');
        let onUpdate = this.onUpdateTask;

        this.state.data
          .filter((i) => i.type === 'TASK')
          .forEach(function (i) {
            let start = moment(i.start).add(diffDays, 'days');
            let end = moment(i.end).add(diffDays, 'days');
            onUpdate(i, { start: start, end: end });
          });
      }
    }

    item.start = moment(props.start);
    item.end = moment(props.end);
    this.setState({ data: [...this.state.data] });
  };

  onSelectItem = (item) => {
    if (item.type === 'OPENITEM' && this.props.onOpenItemClick) {
      this.props.onOpenItemClick(item.id);
    }
  };

  updateOpenItems = (props) => {
    this.state.data
      .filter((i) => i.type === 'OPENITEM')
      .forEach(function (item) {
        let oi = props.openItems.find((oi) => oi.id === item.id);
        item.end = moment(oi.due_date).add(1, 'day');
      });
  };
}

Gantt.propTypes = {
  workOrder: PropTypes.object.isRequired,
  tasks: PropTypes.array.isRequired,
  quotes: PropTypes.array.isRequired,
  openItems: PropTypes.array.isRequired,
  onWorkOrderUpdate: PropTypes.func,
  onTaskUpdate: PropTypes.func,
  onOpenItemClick: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/schedule/Gantt.js